import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledCustomerLabelBadge = styled('span')(
  ({ bgColor }) => css`
    position: absolute;
    top: -5px;
    right: -5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${bgColor};
    z-index: 1;

    .icon {
      filter: brightness(0) invert(1);
    }
  `
);
